import { Prices } from 'utils/types';
import { StyledActualPrice } from './style';
import { Player } from '@lottiefiles/react-lottie-player';

interface IActualPriceProps {
  prices: Prices;
  textShadow?: string;
  textColor?: string;
  buttonSuffixImage?: string;
  buttonSuffixAnimation?: string;
}

export const ActualPrice: React.FC<IActualPriceProps> = ({
  prices,
  textShadow = '0px 1px 1px rgba(0, 0, 0, 0.3)',
  textColor,
  buttonSuffixImage = '',
  buttonSuffixAnimation = '',
}) => {
  const { priceInUsdCents, priceDisplay, strokedPriceDisplay } = prices;
  return (
    <StyledActualPrice textShadow={textShadow}>
      {priceInUsdCents && (
        <span
          style={
            textColor
              ? {
                  color: textColor,
                }
              : undefined
          }
          className="final-price"
        >
          {priceDisplay}
          {(buttonSuffixImage || buttonSuffixAnimation) && (
            <div className="offer-button-asset-container">
              +{' '}
              {buttonSuffixAnimation && (
                <Player
                  autoplay
                  loop
                  className="offer-button-asset"
                  src={buttonSuffixAnimation}
                />
              )}
              {buttonSuffixImage && (
                <img
                  className="offer-button-asset"
                  src={buttonSuffixImage}
                  alt="offer asset"
                />
              )}
            </div>
          )}
        </span>
      )}
      {strokedPriceDisplay && (
        <span className="stroked">{strokedPriceDisplay}</span>
      )}
    </StyledActualPrice>
  );
};
